import { getHeadings } from '@prishapolicy/markdown';
import { useEffect } from 'react';

export const TableOfContents = ({ headings }: { headings: ReturnType<typeof getHeadings> }) => {
  const handleScroll = () => {
    window.scrollTo(window.scrollX, window.scrollY - 80);
  };
  useEffect(() => {
    window.addEventListener('hashchange', handleScroll);
    return () => {
      window.removeEventListener('hashchange', handleScroll);
    };
  });
  return (
    <div className="bg-white pb-5">
      <h5 className="heading-5 mb-6">Table of Contents</h5>
      {headings.map((heading, idx) => {
        return (
          <a className="mb-0.5 block" href={heading.link} key={idx}>
            {heading.text}
          </a>
        );
      })}
    </div>
  );
};

export default TableOfContents;
